module.exports = __webpack_public_path__ + "static/img/logo.1d584798.jpg";